import { MapPin, Users, Mail, FileText, TrendingUp, Plus, ArrowRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

export const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    {
      label: "Laufliste",
      description: "Gebiete bearbeiten",
      icon: MapPin,
      color: "text-blue-600",
      bgColor: "bg-blue-100",
      onClick: () => navigate('/running-list')
    },
    {
      label: "Kunden",
      description: "Kundendaten verwalten",
      icon: Users,
      color: "text-emerald-600",
      bgColor: "bg-emerald-100",
      onClick: () => navigate('/customers')
    },
    {
      label: "E-Mail",
      description: "Postfach öffnen",
      icon: Mail,
      color: "text-violet-600",
      bgColor: "bg-violet-100",
      onClick: () => navigate('/email/inbox')
    },
    {
      label: "Wissensbank",
      description: "Dokumente & Infos",
      icon: FileText,
      color: "text-amber-600",
      bgColor: "bg-amber-100",
      onClick: () => navigate('/archive')
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {actions.map((action) => {
        const Icon = action.icon;
        return (
          <Card 
            key={action.label}
            className="cursor-pointer group hover:shadow-md transition-all duration-200 hover:scale-[1.02] active:scale-[0.98] border-2 border-transparent hover:border-primary/10"
            onClick={action.onClick}
          >
            <CardContent className="p-4">
              <div className="flex flex-col items-center text-center gap-2">
                <div className={cn("p-3 rounded-xl transition-transform group-hover:scale-110", action.bgColor)}>
                  <Icon className={cn("h-5 w-5", action.color)} />
                </div>
                <div>
                  <p className="font-semibold text-sm">{action.label}</p>
                  <p className="text-xs text-muted-foreground hidden sm:block">{action.description}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
